import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';
import RSVPForm from '../../RSVPTemplates/RSVPForm';
import PreviewModeNotice from './PreviewModeNotice';
import RsvpSurfaceShell from './RsvpSurfaceShell';

export default function RsvpCard({ section, data, theme, settings, rsvpRef }) {
  const anim = section.animation || {};
  const cs = data.customStyle || {};
  const bg = data.background;
  const motionPreset = settings?.motionPreset || 'none';
  const disableAnim = motionPreset !== 'none';
  const isDark = isColorDark(cs.bgColor || theme.bg);
  const defaultCardBg = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.03)';

  return (
    <RsvpSurfaceShell
      cs={cs}
      background={bg}
      naturalMaxWidthRem={24}
      borderRadiusRem={1.25}
      contentPaddingClass="p-6 sm:p-8"
      sectionPaddingClass="px-5 py-20"
      surfaceBgColor={cs.bgColor || defaultCardBg}
      surfaceBorderColor={cs.textColor ? `${cs.textColor}20` : undefined}
      rsvpRef={rsvpRef}
    >
      <PreviewModeNotice visible={!!settings?.disableRsvpSubmit} />
      <AnimatedSection preset={anim.section || 'fade-up'} disableAnimation={disableAnim}>
        <p
          className="text-xs tracking-[0.3em] uppercase mb-3 text-center"
          style={{ color: cs.accentColor || theme.accent, fontFamily: cs.fontFamily || theme.eyebrowFont }}
        >
          {data.title || 'RSVP'}
        </p>
        <p className="text-center text-sm mb-8" style={{ color: cs.textColor || theme.textSecondary, fontFamily: cs.fontFamily || undefined }}>
          {data.description || "We'd love to know if you can make it"}
        </p>
      </AnimatedSection>
      <AnimatedSection preset={anim.section || 'fade-up'} delay={0.1} disableAnimation={disableAnim}>
        <RSVPForm
          slug={settings.slug}
          accentColor={cs.accentColor || theme.accent}
          labels={data.labels}
          buttonShadowStrength={cs.buttonShadowStrength}
          customStyle={cs}
          disableSubmit={settings?.disableRsvpSubmit}
        />
      </AnimatedSection>
    </RsvpSurfaceShell>
  );
}

function isColorDark(hex) {
  if (!hex) return false;
  const c = hex.replace('#', '');
  if (c.length < 6) return false;
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}
